module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAeFBMVEUAAAD/AAD/AAD/AED/Kir/IED/MzP/Jzv/KDb/Jjn/KDj/K0D/LD7/Kz3/Kzz/Kz//Kz3/Kj3/Kjz/Kz3/Kz3/Kz3/LD3/Kz7/Kz3/Kzz/Kz3/Kzz/LD3/LD3/Kj3/Kz3/Kz3/Kj3/Kz3/Kz3/Kz3/Kj3/Kz3/Kz3xlnweAAAAJ3RSTlMAAQIEBggKDRMbICQpKi81O2Byjo+WnqWmrbS6u8HY3eHl5unt8POv4REwAAAAb0lEQVQoz52RWQ6CUBAEWWRRkAe4gywiWPe/oRfoSYD+rUymU+15O1NMbSJBDV2sQNrDO1LkOEBzUOQ0witUJJvgEShy/sLdl51nuMnSboGLvCl/UG0BboGrv/55btTNPvAM1iuxJJrazaHMaTfkD9/yCveaf89EAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/task/red-arrow.png
// module id = xlMd
// module chunks = 212